const getStylePropertyValue = (element: HTMLElement, property: string): number => {
    return Number(element.style.getPropertyValue(property).split('rem')[0]) || 0;
};

const setStylePropertyValue = (element: HTMLElement, property: string, value: number): void => {
    element.style.setProperty(property, `${value}rem`);
};

export enum ScrollPosition {
    Start = 'start',
    End = 'end',
    Middle = 'middle',
}

const getHorizontalScrollPosition = (element: HTMLElement): ScrollPosition => {
    const { scrollLeft, scrollWidth, clientWidth } = element;

    if (scrollLeft === 0) {
        return ScrollPosition.Start;
    } else if (Math.ceil(scrollLeft + clientWidth) >= scrollWidth) {
        return ScrollPosition.End;
    } else {
        return ScrollPosition.Middle;
    }
};

const containsImgTag = (htmlString: string): boolean => {
    return htmlString.includes('<img ');
};

const getStylePosition = (position?: string) =>
    position === 'left' ? 'justify-start' : position === 'right' ? 'justify-end' : 'justify-center';

export const HtmlHelpers = {
    getStylePropertyValue,
    setStylePropertyValue,
    getHorizontalScrollPosition,
    containsImgTag,
    getStylePosition,
};
